module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "d-select text-dark",
    class: {
      'openFromBottom': _vm.openFromBottom
    }
  }, [_c('div', {
    staticClass: "width-100 no-print",
    class: {
      'box-shadow': _vm.boxShadow
    }
  }, [_c('div', {
    staticClass: "d-select__input-look",
    class: {
      'active': _vm.showDropdown
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._l((_vm.usersThatAreSelected), function(selectedUser) {
    return _c('div', {
      staticClass: "d-select__selected__item",
      class: {
        'readyToDelete': _vm.isReadyToDelete(selectedUser)
      }
    }, [_vm._v("\n        " + _vm._s(selectedUser.name) + "\n        "), (_vm.userOccEvents(selectedUser) && _vm.userOccEvents(selectedUser).length > 0) ? [_c('div', {
      staticClass: "icon-warning item__icon-warning marg-5-left",
      class: {
        'item_icon__hide': selectedUser.occupied.events.length === 1 && selectedUser.occupied.events[0].event_type === 'presence' || selectedUser.isOnLesson && selectedUser.occupied.events.length === 1
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "d-select__selected__item__secret-label"
    }, _vm._l((_vm.userOccEvents(selectedUser)), function(event, index) {
      return (index < 3) ? _c('div', {
        staticClass: "d-select__selected__item__secret-label__event"
      }, [_vm._v("\n              " + _vm._s(event.title) + "\n            ")]) : _vm._e()
    }), 0)] : _vm._e(), _vm._v(" "), (!selectedUser.isErrorUser) ? _c('div', {
      staticClass: "d-select__selected__item__remove",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeUser(selectedUser)
        }
      }
    }, [_c('span', [_vm._v("×")])]) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.isLoading) ? [_c('spinner', {
    staticStyle: {
      "margin": "7px 0 0 0"
    },
    attrs: {
      "color": "blue",
      "size": "small"
    }
  })] : [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    ref: "inputfield",
    staticClass: "d-select__header__search",
    class: [{
      'show': _vm.showDropdown
    }, {
      'input-active': _vm.searchText.length > 0 || _vm.selectedUsers.length < 1
    }],
    attrs: {
      "type": "search",
      "placeholder": _vm.placeholderText
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "keypress": [function($event) {
        return _vm.selectWithKeyboard('', $event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.selectWithKeyboard('enter')
      }],
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.selectWithKeyboard('down')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        return _vm.selectWithKeyboard('up')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
        return _vm.deleteUserWithKeyboard.apply(null, arguments)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  })]], 2), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
    staticClass: "d-select__items"
  }, [_c('ul', {
    ref: "dropdown",
    staticClass: "d-select__items__container"
  }, [(_vm.isUpdatingUsers) ? [_c('li', {
    staticClass: "item-template flex space-between"
  }, [_c('spinner', {
    staticStyle: {
      "margin": "4px 0 0 0"
    },
    attrs: {
      "color": "blue",
      "size": "small"
    }
  })], 1)] : _vm._l((_vm.searchedUsers), function(item, index) {
    return [_c('li', {
      key: item.user_id,
      class: [{
          'isReadyForSelection': _vm.isSelectedWithKeyboard(item)
        },
        {
          'item_is_selected': _vm.isSelected(item)
        }
      ],
      on: {
        "mouseenter": function($event) {
          return _vm.setIsReadyForSelection(item, index)
        },
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleUser(item)
        }
      }
    }, [(item.occupied && item.occupied.events.length > 0) ? [_c('div', {
      staticClass: "item-template isOccupied",
      class: [{
          'item-is-present': item.occupied.events.length === 1 && item.occupied.events[0].event_type === 'presence'
        },
        {
          'item-is-already-attached': item.isOnLesson
        }
      ]
    }, [(item.icon) ? _c('span', {
      staticClass: "marg-10-right",
      class: item.icon
    }) : _vm._e(), _vm._v(" "), (item.default_thumb_url) ? _c('img', {
      attrs: {
        "src": item.default_thumb_url
      }
    }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "warning-signs"
    }, [_vm._l((item.occupied.events), function(event) {
      return [(event.event_type !== 'presence') ? [(item.isOnLesson && item.currentEventId === event.event_id) ? _c('div', {
        staticClass: "marg-10-left"
      }, [_c('span', {
        staticClass: "icon-user"
      }), _vm._v(" " + _vm._s(_vm.i18n['also_assigned']) + "\n                      ")]) : _vm._e(), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (item.currentEventId !== event.event_id),
          expression: "item.currentEventId !== event.event_id"
        }],
        staticClass: "marg-10-left warning-signs__sign"
      }, [_c('span', {
        staticClass: "icon-warning"
      }), _vm._v(" " + _vm._s(event.title) + "\n                      ")])] : _vm._e(), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (item.occupied.events.length === 1 && event.event_type === 'presence'),
          expression: "item.occupied.events.length === 1 && event.event_type === 'presence'"
        }],
        staticClass: "marg-10-left"
      }, [_c('span', {
        staticClass: "icon-clock"
      }), _vm._v(" " + _vm._s(_vm.i18n['working_hours']) + ": " + _vm._s(_vm._f("localeTime")(event.event_time_start)) + " -\n                      " + _vm._s(_vm._f("localeTime")(event.event_time_end)) + "\n                    ")])]
    })], 2)])] : _c('div', {
      staticClass: "item-template"
    }, [(item.icon) ? _c('span', {
      staticClass: "marg-10-right",
      class: item.icon
    }) : _vm._e(), _vm._v(" "), (item.default_thumb_url) ? _c('img', {
      attrs: {
        "src": item.default_thumb_url
      }
    }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.name))])])], 2)]
  })], 2), _vm._v(" "), (_vm.searchedUsers.length < 1) ? _c('div', {
    staticClass: "no-match"
  }, [_vm._t("noMatch", function() {
    return [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.dselect.no_matching_results')))])]
  })], 2) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [(_vm.subFromIsOnLesson !== null) ? _c('div', {
    staticClass: "subModal__bg"
  }, [_c('div', {
    staticClass: "subModal"
  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n['would_you_like_to_set']) + " " + _vm._s(_vm.subFromIsOnLesson.name) + " " + _vm._s(_vm.i18n['as_a_substitute_instead_of_teacher']) + "?")]), _vm._v(" "), _c('div', {
    staticClass: "subModal__buttons"
  }, [_c('button', {
    on: {
      "click": _vm.setSubFromIsOnLesson
    }
  }, [_vm._v(_vm._s(_vm.i18n['yes']))]), _vm._v(" "), _c('button', {
    staticClass: "bttn-simple bttn",
    on: {
      "click": function($event) {
        _vm.subFromIsOnLesson = null
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n['no']))])])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-088a62da!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DSelect/DSelectSubsSub.vue
// module id = 1464
// module chunks = 1